/*
 * AI agents such as the Claude browser plugin look for HTML elements such as "button" to determine
 * that something is clickable. We use the "data-testid" attribute to identify elements that are clickable
 * by AI agents in cases where they might otherwise be confused.
 */
export const AI_AGENTS_PREFIX = 'ai-agents';
